import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=5880b16e&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=5880b16e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5880b16e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5880b16e')) {
      api.createRecord('5880b16e', component.options)
    } else {
      api.reload('5880b16e', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=5880b16e&scoped=true&", function () {
      api.rerender('5880b16e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8HyQL0UOwUS3s/JS/comp/GuestBox.vue"
export default component.exports